module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-fill-0455dabe.svg";